import AOS from 'aos';
import 'aos/dist/aos.css';

// DOMContentLoadedイベントでAOSを初期化
document.addEventListener('DOMContentLoaded', function() {
  AOS.init({
    duration: 1000, // アニメーションの速度（ミリ秒）
    delay: 500,
    offset: 100,    // スクロールでアニメーションを開始するオフセット
    once: true,     // アニメーションを1回だけ実行
  });
});